import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.css';

interface SidebarProps {
  customerName?: string;
  onSignOut: () => void;
}

const NAV_ITEMS = [
  { to: '/', label: 'Dashboard', icon: '~' },
  { to: '/getting-started', label: 'Getting Started', icon: '>' },
  { to: '/licenses', label: 'Licenses', icon: '#' },
  { to: '/css', label: 'CSS Editor', icon: '{' },
  { to: '/account', label: 'Account', icon: '@' },
  { to: '/upgrade', label: 'Upgrade', icon: '^' },
];

export function Sidebar({ customerName, onSignOut }: SidebarProps) {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.logo}>
        <span className={styles.logoText}>ChikChak Labs</span>
        <span className={styles.logoSub}>My Account</span>
      </div>

      <nav className={styles.nav}>
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              `${styles.navItem} ${isActive ? styles.navItemActive : ''}`
            }
          >
            <span className={styles.navIcon}>{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className={styles.footer}>
        {customerName && <div className={styles.userName}>{customerName}</div>}
        <button className={styles.signOutBtn} onClick={onSignOut}>
          Sign Out
        </button>
      </div>
    </aside>
  );
}
